import { useTranslation } from 'react-i18next';

import { gql, useMutation } from '@apollo/client';
import { showNotification, NOTIFICATION_TYPE } from '@thinknet-gmbh/platform-common-ui';

import { IHookCallbacks } from 'src/hooks/common.hooks.interfaces';

import { GET_MEMBERS } from './get-members.hook';

export const UPDATE_MEMBER_PERMISSION_GROUP_AND_GANTT_ACCESS = gql`
  mutation updateMemberPermissionGroupAndGanttAccess(
    $ganttsAccessPayload: [UpdateGanttAccessPayloadInput!]!
    $permissionGroupPayload: UpdateMemberPermissionGroupInput!
  ) {
    updateMemberPermissionGroupAndGanttAccess(
      ganttsAccessPayload: $ganttsAccessPayload
      permissionGroupPayload: $permissionGroupPayload
    ) {
      _id
    }
  }
`;

export const useUpdateMemberPermissionGroupAndGanttAccess = ({ onSuccess }: IHookCallbacks) => {
  const { t } = useTranslation('settings');

  const [updateMemberPermissionGroupAndGanttAccess] = useMutation(
    UPDATE_MEMBER_PERMISSION_GROUP_AND_GANTT_ACCESS,
    {
      refetchQueries: [GET_MEMBERS],
      onCompleted: () => {
        onSuccess();
        showNotification({
          type: NOTIFICATION_TYPE.success,
          isIcon: false,
          message: t('userProfileSettings.success.profileChanges.title'),
        });
      },
      onError: ({ graphQLErrors }: { graphQLErrors?: any }) => {
        const [error] = graphQLErrors;
        const errorStatusCode = error?.extensions?.exception?.status;
        const subTitle =
          errorStatusCode === 406 // NOT_ACCEPTABLE
            ? t('userProfileSettings.permissionGroupError.subTitle')
            : t('userProfileSettings.error.subTitle');
        showNotification({
          type: NOTIFICATION_TYPE.error,
          message: t('userProfileSettings.error.title'),
          description: subTitle,
        });
      },
    }
  );

  return updateMemberPermissionGroupAndGanttAccess;
};
